module.exports = __webpack_public_path__ + "media/manage.a5dc948f.mp4";